module.exports = __webpack_public_path__ + "assets/5d1746d68792845ab9f1f00e72cc3b07.png";